const isDesktop = window.matchMedia("(min-width: 768px)").matches;

const fadeInAnimation = () => {
  const elements = document.querySelectorAll('[data-animation="fade-in"]');

  if (!elements) return;

  elements.forEach((element) => {
    const { animationStart, animationMarkers } = element.dataset;
    const defaultStart = "-40px 85%";
    const start = animationStart || defaultStart;

    if (isDesktop) {
      gsap.fromTo(
        element,
        { opacity: 0, y: 150 },
        {
          opacity: 1,
          y: 0,
          duration: 1.5,
          ease: "back.out(1.2)",
          scrollTrigger: {
            trigger: element,
            start,
            toggleActions: "play none none none",
            markers: !!animationMarkers,
          },
        },
      );
    }
  });
};

export default fadeInAnimation;
